import { customerDeliveryfileListDetailService } from '@services/private/customer-delivery/file-list-detail.service';
import { generateQueryString } from '../strings/shared-helpers-strings';
import {
  CustomerDeliveryFileStatus,
  CustomerDeliveryFileUploadStatus,
} from 'types';
import { is200xRange } from '@utils/utilities';
import { updateState } from '../update-state';

type ListDataType = {
  page: number;
  size: number;
  adminConfigEnv: {
    cssJsVersion: string;
  } | null;
  sortName:
    | ''
    | 'otmSubject'
    | 'lfsUploadSt'
    | 'otmfOriginName'
    | 'otmSt'
    | 'expirationYmd'
    | 'regDt'
    | null;
  sortType: string | null;
  schOtmSt: CustomerDeliveryFileUploadStatus | '';
  schGroup: string;
  schKeyword: string;
  otmList:
    | [
    {
      otmSeq: string;
      otmSubject: string;
      otmfOriginName: null | string;
      otmfSize: number;
      otmSt: CustomerDeliveryFileStatus;
      expirationYmd: string;
      regDt: string;
      lfsUploadSt: CustomerDeliveryFileUploadStatus;
      regName: null | string;
    },
  ]
    | [];
  totalCount: number;
};

export const getCustomerDeliveryFileList = async (
  listData: ListDataType,
  payload = [],
  stateSetter,
  fields,
) => {
  const { page, size, sortName, sortType, schOtmSt, schGroup, schKeyword } =
    listData;

  const queryString = generateQueryString(
    [
      { key: 'page', value: page },
      { key: 'size', value: size },
      { key: 'sortName', value: sortName },
      { key: 'sortType', value: sortType },
      { key: 'schOtmSt', value: schOtmSt },
      { key: 'schGroup', value: schGroup },
      { key: 'schKeyword', value: schKeyword },
    ].map((item) => {
      return fields.includes(item.key)
        ? payload.find((field) => {
          // @ts-ignore
          return field.key === item.key;
        })
        : item;
    }),
  );

  const { response, statusCode } =
    await customerDeliveryfileListDetailService(queryString);

  if (response?.code === '1' && is200xRange(statusCode)) {
    const list = [
      { key: 'adminConfigEnv', value: response?.result?.adminConfigEnv },
      { key: 'otmList', value: response?.result?.otmListInfo?.otmList },
      {
        key: 'totalCount',
        value: response?.result?.otmListInfo?.totalCount,
      },
    ];

    payload.forEach((item) => {
      list.push(item);
    });

    updateState(list, stateSetter);
  }
};
